import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";
import { IZCoreAIChat } from "./ZCoreAIChat";

export interface IZCoreAIChatUser extends IEntity {
    UserID?: number;
    ChatID?: number;
    User?: IUser;
    Chat?: IZCoreAIChat;
}

export class ZCoreAIChatUser extends Entity implements IZCoreAIChatUser {
    public UserID = null;
    public ChatID = null;
    public Chat = null;

    constructor() {
        super();
    }
}